<template>
  <div style="width: 1800px;">
    <canvas
      v-show="lineChartShow"
      ref="trendCanvas"
      :width="canvas.width"
      :height="canvas.height"
      class="trend-canvas"
    ></canvas>
    <table ref="trendTable" class="chart-table" style='border-collapse:collapse'>
      <thead ref="Head">
        <tr class="title-text">
          <th ref="periodsHead" rowspan="2" colspan="3" class="border-bottom border-right border-left">期号</th>
          <th ref="drawnumbHead" rowspan="2" colspan="3" class="border-bottom border-right">开奖号码</th>
          <th ref="blueballWidth" colspan="37" class="border-right">蓝球区域</th>
          <th colspan="16" class="border-right">黄球区域</th>
        </tr>
        <tr class="title-number">
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(num, rindex) in lotteryNumbHead" :key="rindex + 'blue'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
          <th class="ball-none border-bottom-header"></th>
          <th class="border-bottom-header" v-for="(num, bindex) in lotteryNumbHead.slice(0,12)" :key="bindex + 'yellow'">
            <i class="ball-noraml">{{ num }}</i>
          </th>
          <th class="ball-none border-bottom-header border-right"></th>
        </tr>
      </thead>
      <tbody>
        <tr class="border-left" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" v-for="(item, index) in lotteryTrendList" :key="index + 'lotteryTrend'">
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="issue-numbers" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}">{{ item.periodsNumber }}</td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td class="ball-none" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"><span class="lottery-numbers">{{ item.drawingNumber }}</span></td>
          <td class="ball-none border-right" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}"></td>
          <!-- 蓝球区域 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="nindex + 'rednum'" v-for="(num, nindex) in blueballTableList[index]">
            <i class="ball-noraml openNo paddssqb" v-if="num === 'A'">{{ lotteryNumbHead[nindex].toString().padStart(2, '0') }}</i>
            <i class="ball-noraml" v-else-if="missNumberShow">{{ num.toString() }}</i>
            <i class="ball-noraml" v-else></i>
          </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
          <!-- 黄球区域 -->
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none"></td>
            <td style="width:32px;" id="smallRect" :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" :key="bindex + 'bluenum'" v-for="(num, bindex) in yellowballTableList[index]">
              <i class="ball-noraml openNo padddlty" v-if="num === 'A'">{{ lotteryNumbHead[bindex] ? lotteryNumbHead[bindex].toString().padStart(2, '0') : '' }}</i>
              <i class="ball-noraml" v-else-if="missNumberShow">{{ num }}</i>
              <i class="ball-noraml" v-else></i>
            </td>
          <td :class="{'border-bottom': (index + 1) % 5 === 0 || index === lotteryTrendList.length - 1}" class="ball-none border-right"></td>
        </tr>
      </tbody>
      <tfoot v-show="statisticalShow" v-if="lotteryTrendList&&lotteryTrendList.length > 0">
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">出现总次数</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td>
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" :key="index" v-for="(count, index) in blueballStatisticaList.countArr">
            <i class="ball-noraml">{{ count }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom" v-for="(total, sindex) in yellowballStatisticaList.countArr" :key="sindex + 'total'">
            <i class="ball-noraml">{{ total }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">平均遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="amindex" v-for="(averageMiss, amindex) in blueballStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ averageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="tamindex + 'averageMissArr'" v-for="(totalAverageMiss, tamindex) in yellowballStatisticaList.averageMissArr">
            <i class="ball-noraml">{{ totalAverageMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大遗漏值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="mmindex" v-for="(maxMiss, mmindex) in blueballStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ maxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="tmmindex + 'maxMissArr'" v-for="(totalMaxMiss, tmmindex) in yellowballStatisticaList.maxMissArr">
            <i class="ball-noraml">{{ totalMaxMiss }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
        <tr class="border-bottom border-left">
          <td class="ball-none border-bottom"></td> 
          <td class="issue-numbers border-bottom">最大连出值</td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td>
          <td class="border-bottom"><span class="lottery-numbers"></span></td> 
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="mcindex" v-for="(maxContinuity, mcindex) in blueballStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ maxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td> 
          <td class="ball-none border-bottom"></td> 
          <td class="border-bottom" :key="tmcindex + 'maxContinuity'" v-for="(totalMaxContinuity, tmcindex) in yellowballStatisticaList.maxContinuity">
            <i class="ball-noraml">{{ totalMaxContinuity }}</i>
          </td>
          <td class="ball-none border-right border-bottom"></td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<script>
import mix from "../../../mixins/trendChart.mixins.vue";
export default {
  name: 'DltChart',
  mixins: [mix],
  data() {
    return {
      yellowballNumbHead: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
    }
  },
  computed: {
    blueballArr() {
      let list = []
      this.lotteryTrendList.forEach(obj => {
        list.push(obj.drawingNumber.split(',').slice(0, -2))
      })
      return list
    },
    blueballTableList() {
      return this.chartList(this.blueballArr)
    },
    yellowballArr() {
      let list = []
      this.lotteryTrendList.forEach(obj => {
        list.push(obj.drawingNumber.split(',').slice(-2))
      })
      return list
    },
    yellowballTableList() {
      return this.chartList(this.yellowballArr, this.yellowballNumbHead)
    },
    blueballStatisticaList() {
      return this.statistica(this.lotteryNumbHead,this.blueballTableList)
    },
    yellowballStatisticaList() {
      return this.statistica(this.yellowballNumbHead,this.yellowballTableList)
    }
  },
  mounted() {
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArrayCanvas(this.openNumSperateTrendList.slice(-2));
        }, 0);
      });
    });
  },
  updated() {
    this.$nextTick((e) => {
      let tableDom = this.$refs.trendTable;
      if (!tableDom) return;

      //获取表格宽高
      let tbWidth = tableDom.offsetWidth;
      let tbHeight = tableDom.offsetHeight;

      //设置canvas宽高
      this.canvas.width = tbWidth;
      this.canvas.height = tbHeight;
      this.$nextTick((e) => {
        setTimeout((e) => {
          this.drawArrayCanvas(this.openNumSperateTrendList.slice(-2));
        }, 0);
      });
    });
  },
  methods: {
    getArrayChartCoordinate(Coordinate) {
        if (!this.$refs.drawnumbHead || !this.$refs.blueballWidth) return [];
        let chartCoordinate = [];

        Coordinate.forEach((trendList, trendIndex) => {
          //获取坐标系
          let len = trendList.length;
          console.log('len', len)
          if (len == 0) return [];

          //先获取表格左边不需要折线部分的宽度
          let dwidth = this.$refs.drawnumbHead.offsetWidth;
          let bwidth = this.$refs.blueballWidth.offsetWidth;
          let pwidth = this.$refs.periodsHead.offsetWidth;
          //左边总宽度
          let leftCountWidth = dwidth + pwidth + bwidth;
          //上边总高度
          let topCountWidth = this.$refs.Head.offsetHeight; // 上面总高度
          //表格td宽度 表格td高度
          if(!document.getElementById("smallRect")) {
            return;
          }
          const tdWidth = document.getElementById("smallRect").offsetWidth;
          const tdHeight = document.getElementById("smallRect").offsetHeight;

          let list = [];

          for (let i = 0; i < len; i++) {
            let numb = Number(this.lotteryNumbHead[trendList[i].indexOf("A")]);
            let index = this.lotteryNumbHead.indexOf(numb);
            let x = leftCountWidth + (tdWidth * index + ( tdWidth / 2)) + 5;
            let y = topCountWidth + (tdHeight * i + tdHeight / 2);
            list.push([x, y]);
          }
          chartCoordinate.push(list);
        });
        return chartCoordinate;
      },
  }
}
</script>

<style>

</style>